(function () {
  "use strict";

  function createId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `tk-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }

  function addMatch(index, key, group) {
    if (!key) return;
    const normalized = String(key);
    const matches = index.get(normalized) || [];
    matches.push(group);
    index.set(normalized, matches);
  }

  function oneMatch(index, key) {
    const matches = index.get(String(key || "")) || [];
    return matches.length === 1 ? matches[0] : null;
  }

  function group(items, isAddonItem, addonCategory) {
    const activeItems = (items || []).filter((item) => Number(item.quantity) > 0);
    const groups = [];
    const groupsById = new Map();
    const groupsByVariant = new Map();
    const groupsByHandle = new Map();
    const addons = [];

    activeItems.forEach((item) => {
      if (isAddonItem(item)) {
        addons.push(item);
        return;
      }

      const itemGroup = {
        item,
        addons: [],
        allAddons: [],
        addonTypes: new Set(),
        groupId: item.properties?._tk_addon_group_id || "",
      };
      groups.push(itemGroup);
      addMatch(groupsById, itemGroup.groupId, itemGroup);
      addMatch(groupsByVariant, item.variant_id, itemGroup);
      addMatch(groupsByHandle, item.handle, itemGroup);
    });

    const redundantKeys = [];
    addons.forEach((item) => {
      const linkedGroupId = item.properties?._addon_parent_group_id;
      const parentVariantId = item.properties?._addon_parent_variant_id;
      const parentHandle = item.properties?._addon_parent_handle;
      let parentGroup = null;

      if (linkedGroupId) {
        parentGroup = oneMatch(groupsById, linkedGroupId);
      } else if (parentVariantId) {
        const variantMatches = groupsByVariant.get(String(parentVariantId)) || [];
        if (variantMatches.length === 1) parentGroup = variantMatches[0];
      } else {
        parentGroup = oneMatch(groupsByHandle, parentHandle);
      }

      if (!parentGroup) {
        groups.push({ item, addons: [], allAddons: [], addonTypes: new Set(), groupId: "", orphanAddon: true });
        return;
      }

      parentGroup.allAddons.push({ item });
      const category = addonCategory(item);
      if (parentGroup.addonTypes.has(category)) {
        redundantKeys.push(item.key);
        return;
      }

      parentGroup.addonTypes.add(category);
      parentGroup.addons.push({ item });
    });

    return { groups, redundantKeys };
  }

  async function fetchConfiguredUpsell(groups) {
    for (const group of groups || []) {
      if (!group.item.handle || !group.item.variant_id) continue;
      try {
        const url = `/products/${encodeURIComponent(group.item.handle)}?view=addons&variant=${encodeURIComponent(group.item.variant_id)}`;
        const response = await fetch(url, { headers: { Accept: "application/json" } });
        if (!response.ok) continue;
        const data = await response.json();
        const existingTypes = group.addonTypes || new Set();
        const addon = (data.addons || []).find((item) => {
          const type = String(item.type || "").toLowerCase();
          const category = type.includes("battery") ? "battery" : type.includes("warranty") ? "warranty" : type;
          return category && !existingTypes.has(category);
        });
        if (addon) return [{ ...addon, parentKey: group.item.key }];
      } catch (error) {}
    }
    return [];
  }

  window.tkCartAddonGroups = { createId, group, fetchConfiguredUpsell };
})();
